import Stack from '../../../../../components/Stack/Stack';
import BoatModelCategory from '../../../../types/BoatModelCategory';
import BoatModelWithMedia from '../../../../types/BoatModelWithMedia';
import BoatModelCardsOfCategory from '../BoatModelCardsOfCategory/BoatModelCardsOfCategory';

type BoatModelsPerCategoryProps = {
    categories: Array<BoatModelCategory>;
    boatModels: Array<BoatModelWithMedia>;
    onPreview: (boatModel: BoatModelWithMedia) => void;
    onSelect: (boatModel: BoatModelWithMedia, quantity: number) => void;
    minimumPassengers?: number;
    categoryId?: string;
    customerWantsMultipleDays: boolean | undefined;
};

const BoatModelsPerCategory = ({
    categories,
    boatModels,
    onPreview,
    onSelect,
    categoryId,
    minimumPassengers,
    customerWantsMultipleDays,
}: BoatModelsPerCategoryProps) => {
    const filteredBoatModels = minimumPassengers
        ? boatModels.filter(
              (boatModel) => boatModel.capacity >= minimumPassengers
          )
        : boatModels;

    const filteredCategories = categoryId
        ? categories.filter((category) => category.id === categoryId)
        : categories;

    const modelsWithoutCategory = filteredBoatModels.filter(
        (bm) => !bm.categoryId
    );

    return (
        <Stack space="xlarge">
            {(categoryId === '' || categoryId === undefined) &&
                modelsWithoutCategory.length > 0 && (
                    <BoatModelCardsOfCategory
                        boatModels={modelsWithoutCategory}
                        category={null}
                        onSelect={onSelect}
                        onPreview={onPreview}
                        customerWantsMultipleDays={customerWantsMultipleDays}
                    />
                )}

            {filteredCategories.map((category) => (
                <BoatModelCardsOfCategory
                    key={category.id}
                    boatModels={filteredBoatModels.filter(
                        (bm) => bm.categoryId === category.id
                    )}
                    category={category}
                    onSelect={onSelect}
                    onPreview={onPreview}
                    customerWantsMultipleDays={customerWantsMultipleDays}
                />
            ))}
        </Stack>
    );
};

export default BoatModelsPerCategory;
